import { getHeaders } from '../request/getHeaders';
import { setFeatureFlagsFromApi } from './featureFlags';
import { IFeatureFlagResponse } from '../../common/interfaces/featureFlags';
import { getItem } from 'helpers/storage';

export const fetchFeatureFlagsFromAPI =
  async (): Promise<IFeatureFlagResponse> => {
    const brandHotelSelection = getItem('brandHotelSelection');
    const hotelId = brandHotelSelection
      ? brandHotelSelection.hotelId
      : undefined;

    const url = hotelId
      ? `${Env.API_URL}/features/check/?hotelId=${hotelId}`
      : `${Env.API_URL}/features/check`;

    const response = await fetch(url, {
      method: 'GET',
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch feature flags: ${response.status} ${response.statusText}`
      );
    }

    const featureFlagsResponse = await response.json();

    setFeatureFlagsFromApi(
      featureFlagsResponse.flags,
      featureFlagsResponse.userContext
    );

    return featureFlagsResponse;
  };
